import { useEffect, useState } from 'react'
import { useAppStore } from '../../shared/store/store'
import { SentryHub, initMonitoring } from '../../../../trillion-common/src/monitoring/monitoring'

export function useMonitoring(jewelryId: string) {
  const viewerConfig = useAppStore((state) => state.viewerConfig)
  const [inited, setInited] = useState(false)

  useEffect(() => {
    initMonitoring(`trillion-viewer@${__APP_VERSION__}`)
    setInited(true)
  }, [])

  useEffect(() => {
    if (inited) {
      SentryHub?.addBreadcrumb({
        message: 'Viewer inited',
        data: {
          jewelryId,
        },
      })
      SentryHub?.setTags({
        jewelryId,
      })
    }
  }, [inited, jewelryId])

  useEffect(() => {
    if (inited && viewerConfig) {
      SentryHub?.addBreadcrumb({
        message: 'Viewer config loaded',
        data: {
          jewelryId: viewerConfig.sku,
          jewelryType: viewerConfig.category,
        },
      })
      SentryHub?.setTags({
        jewelryId: viewerConfig.sku,
        jewelryType: viewerConfig.category,
      })
    }
  }, [inited, viewerConfig])
}
